type Props = {
  children: React.ReactNode | string;
  fontWeight?: number;
  fontSize?: number;
  color?: string;
  style?: React.CSSProperties;
  lineHeight?: number;
  className?: string;
};

const calculateLineHeight = (fontSize: number) => {
  if (fontSize >= 16) return fontSize + 8;
  return fontSize + 4;
};

const Text: React.FC<Props> = ({
  children,
  fontWeight = 400,
  fontSize = 14,
  color = "#44546F",
  style,
  className,
}) => {
  return (
    <span
      className={className}
      style={{
        fontSize,
        fontWeight,
        color,
        lineHeight: `${calculateLineHeight(fontSize)}px`,
        ...style,
      }}
    >
      {children}
    </span>
  );
};

export default Text;
